__turbopack_context__.v({
  "column": "index-module-scss-module__NvjYYa__column",
  "content": "index-module-scss-module__NvjYYa__content",
  "cta": "index-module-scss-module__NvjYYa__cta",
  "description": "index-module-scss-module__NvjYYa__description",
  "eyebrow": "index-module-scss-module__NvjYYa__eyebrow",
  "fade": "index-module-scss-module__NvjYYa__fade",
  "hero-marquee": "index-module-scss-module__NvjYYa__hero-marquee",
  "logoBox": "index-module-scss-module__NvjYYa__logoBox",
  "logoBoxNarrow": "index-module-scss-module__NvjYYa__logoBoxNarrow",
  "logoBoxWide": "index-module-scss-module__NvjYYa__logoBoxWide",
  "logoMark": "index-module-scss-module__NvjYYa__logoMark",
  "media": "index-module-scss-module__NvjYYa__media",
  "mediaInner": "index-module-scss-module__NvjYYa__mediaInner",
  "section": "index-module-scss-module__NvjYYa__section",
  "slide": "index-module-scss-module__NvjYYa__slide",
  "stackNarrowImage": "index-module-scss-module__NvjYYa__stackNarrowImage",
  "stackWideImage": "index-module-scss-module__NvjYYa__stackWideImage",
  "supportingCopy": "index-module-scss-module__NvjYYa__supportingCopy",
  "tall": "index-module-scss-module__NvjYYa__tall",
  "textStack": "index-module-scss-module__NvjYYa__textStack",
  "title": "index-module-scss-module__NvjYYa__title",
  "track": "index-module-scss-module__NvjYYa__track",
  "trackGroup": "index-module-scss-module__NvjYYa__trackGroup",
  "trackViewport": "index-module-scss-module__NvjYYa__trackViewport",
});
